<template>
  <el-dialog
    class="rc-dialog"
    title="记录联系情况"
    :visible.sync="dialogVisible"
    width="560"
    top="30vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
    @close="close"
  >
    <span
      >请确认您已完成与申请人【{{
        user.applyUserName
      }}】的联系，如需记录联系情况，请在下方填写</span
    >
    <el-input
      class="record"
      type="textarea"
      v-model="record"
      placeholder="请输入联系记录（非必填）"
      maxlength="200"
      show-word-limit
    ></el-input>
    <span slot="footer" class="dialog-footer">
      <butn
        class="czButn"
        @click="dialogVisible = false"
        size="small"
        title="取 消"
      />
      <butn type="primary" @click="finish" size="small" title="确 定" />
    </span>
  </el-dialog>
</template>

<script>
import vue from "@/main";
import { lessonApplyContact } from "@/api/lessonApply";
import butn from "@/components/button/index";
export default {
  components: { butn },
  data() {
    return {
      dialogVisible: false,
      user: {},
      record: ""
    };
  },
  created() {
    vue.$on("contacted", user => {
      this.dialogVisible = true;
      this.user = user;
    });
  },
  methods: {
    finish() {
      lessonApplyContact({
        contactContent: this.record,
        uuid: this.user.uuid
      }).then(res => {
        if (!res || res.code != 0) return;
        this.$message({
          message: "操作成功",
          type: "success"
        });
        vue.$emit("reloadList");
        this.dialogVisible = false;
      });
    },
    close() {
      this.record = "";
    }
  }
};
</script>

<style scoped>
.record {
  margin-top: 20px;
}
</style>
